import * as _ from "lodash";

import { Autocomplete, Button, Input, Select, Textarea } from "@mantine/core";
import { IconMail, IconPencil, IconSearch } from "@tabler/icons-react";
import {
  apiUserGetCompany,
  apiUserGetDepartment,
  apiUserPutDepartment,
} from "@/api";
import { useEffect, useState } from "react";

import { Badge } from "antd";
import Card from "@/components/Card";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

function EditDepartmentPage() {
  const { id } = useParams();
  const [departmentData, setDepartmentData] = useState([]);
  const [editDepartmentData, setEditDepartmentData] = useState([]);

  // 可以選擇的資料
  const [memberData, setMemberData] = useState([]);
  const [leaderData, setLeaderData] = useState([]);

  const [tempLeaderData, setTempLeaderData] = useState([]);
  const [tempMemberData, setTempMemberData] = useState([]);

  //當前已經選擇的資料
  const [leaderList, setLeaderList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const navigate = useNavigate();

  const { code, workContent, name, company, leaders, members } =
    departmentData || {};

  const handleRemoveMember = (member, members, setState) => {
    let newMemberData = members?.filter(
      (currMember) => currMember.id !== member.id,
    );
    setState(newMemberData);
  };

  const handleDisplayMembers = (members, setState) => {
    if (!members?.length) {
      return "";
    }

    return members.map((member) => (
      <div className="m-2">
        <Badge
          count="━"
          style={{ cursor: "pointer" }}
          onClick={() => handleRemoveMember(member, members, setState)}
        >
          <Card
            customStyle={{
              baseStyle: { margin: "0rem", width: "200px", height: "120px" },
            }}
            props={member}
          />
        </Badge>
      </div>
    ));
  };

  const handleDisplaySelectMembers = (data) => {
    return data?.map((t) => t?.name + ` (ID: ${t?.id})`);
  };

  const handleSubmit = async ({ id, data }) => {
    try {
      await apiUserPutDepartment({ id, data });
      navigate(`/hrMainPage/department/${id}`);
    } catch (error) {
      console.error("apiUserPutDepartment_ERROR", error);
    }
  };

  const handleEditData = (data, name) => {
    setDepartmentData({
      ...departmentData,
      [name]: data,
    });

    setEditDepartmentData((prevData) => ({
      ...prevData,
      [name]: data,
    }));
  };

  const handleSearchMembers = async (value, leaderData, setState) => {
    let match = value.match(/ID:\s*(\d+)/);
    let idNumber = match ? match[1] : null;

    let selectedData = leaderData.filter((e) => e?.id == idNumber)[0];

    if (selectedData) {
      setState(selectedData);
    } else {
      console.error("handleSearchMembers");
    }
  };

  const handleConfirmLeader = (leaderList, tempLeaderData, setState) => {
    let isInTheList = leaderList?.some((t) => t.id == tempLeaderData.id);
    if (!isInTheList) {
      setState([...leaderList, tempLeaderData]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        //拿department資料
        let result = await apiUserGetDepartment({ id });
        let companyId = localStorage.getItem("companyId");
        //拿company中的leader和member資料
        let companyData = await apiUserGetCompany({ id: companyId });

        let departmentData = result?.data;

        if (departmentData) {
          setDepartmentData(departmentData);
          setLeaderList(departmentData?.leaders);
          setMemberList(departmentData?.members);
        }
        if (companyData?.data) {
          let employees = companyData?.data?.employees;

          setMemberData(employees);
          setLeaderData(employees);
        }
      } catch (error) {
        console.error("Error fetching department data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="w-[765px] rounded-xl bg-white p-14">
        <>
          <div className="flex justify-end">
            <IconPencil
              className="cursor-pointer"
              size={32}
              onClick={() => navigate(`/hrMainPage/editDepartment/${id}`)}
            />
          </div>
          <div className="flex">
            <div>
              <div
                className="py-3 text-2xl font-bold"
                style={{ color: "#6F6F6F" }}
              >
                部門名稱
              </div>
              <Input
                placeholder="Pick value"
                value={name}
                onChange={(e) => handleEditData(e.target.value, "name")}
              />
            </div>
            <div className="pl-3">
              <div
                className="py-3 text-2xl font-bold"
                style={{ color: "#6F6F6F" }}
              >
                部門代號
              </div>
              <Input
                placeholder="Pick value"
                value={code}
                onChange={(e) => handleEditData(e.target.value, "code")}
              />
            </div>
          </div>

          <div className="py-4">
            <div
              className="py-3 text-2xl font-bold"
              style={{ color: "#6F6F6F" }}
            >
              部門描述
            </div>
            <Textarea
              placeholder="Input placeholder"
              value={workContent}
              onChange={(e) => handleEditData(e.target.value, "workContent")}
            />
          </div>

          <div>
            <div className="text-2xl font-bold" style={{ color: "#6F6F6F" }}>
              部門主管
            </div>
            <div className="flex">
              <Autocomplete
                placeholder="輸入主管姓名"
                data={handleDisplaySelectMembers(leaderData)}
                leftSection={<IconSearch size={16} />}
                onChange={(e) =>
                  handleSearchMembers(e, leaderData, setTempLeaderData)
                }
                onOptionSubmit={(e) =>
                  handleSearchMembers(e, leaderData, setTempLeaderData)
                }
              />
              <Button
                variant="filled"
                color="gray"
                style={{ width: "100%", margin: "1rem", maxWidth: "100px" }}
                radius="md"
                onClick={() =>
                  handleConfirmLeader(leaderList, tempLeaderData, setLeaderList)
                }
              >
                新增
              </Button>
            </div>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
              {handleDisplayMembers(leaderList, setLeaderList)}
            </div>
          </div>
          <div>
            <div className="text-2xl font-bold" style={{ color: "#6F6F6F" }}>
              部門成員
            </div>
            <div className="flex">
              <Autocomplete
                placeholder="輸入成員姓名"
                data={handleDisplaySelectMembers(memberData)}
                leftSection={<IconSearch size={16} />}
                onChange={(e) =>
                  handleSearchMembers(e, memberData, setTempMemberData)
                }
                onOptionSubmit={(e) =>
                  handleSearchMembers(e, memberData, setTempMemberData)
                }
              />
              <Button
                variant="filled"
                color="gray"
                style={{ width: "100%", margin: "1rem", maxWidth: "100px" }}
                radius="md"
                onClick={() =>
                  handleConfirmLeader(memberList, tempMemberData, setMemberList)
                }
              >
                新增
              </Button>
            </div>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
              {handleDisplayMembers(memberList, setMemberList)}
            </div>
          </div>
          <div className="flex">
            <Button
              variant="default"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => navigate(`/hrMainPage/department/${id}`)}
            >
              取消修改
            </Button>

            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => {
                let submitData = { ...editDepartmentData };

                if (leaderList.length) {
                  submitData = {
                    ...submitData,
                    leaders: leaderList?.map((t) => t.documentId),
                  };
                }

                if (memberList.length) {
                  submitData = {
                    ...submitData,
                    members: memberList?.map((t) => t.documentId),
                  };
                }

                handleSubmit({
                  id,
                  data: submitData,
                });
              }}
            >
              確認修改
            </Button>
          </div>
        </>
      </div>
    </div>
  );
}

export default EditDepartmentPage;
